import { notification } from "antd";

const showNotification = (type, description, title) => {
  const defaultTitle =
    type === "success"
      ? "Success"
      : type === "error"
        ? "Error"
        : type === "warning"
          ? "Warning"
          : "Notification";

  notification[type]({
    message: title || defaultTitle,
    description: description,
  });
};

export const showSuccessNotification = (description, title) => {
  showNotification("success", description, title);
};

export const showErrorNotification = (description, title) => {
  if (
    typeof description === "string" &&
    description.trim().toLowerCase() === "success"
  ) {
    showSuccessNotification("Operation completed successfully.", title);
    return;
  }
  showNotification("error", description, title);
};

export const showWarningNotification = (description, title) => {
  showNotification("warning", description, title);
};

export const showInfoNotification = (description, title) => {
  showNotification("info", description, title);
};
